import { createSelector } from 'reselect';

import { PcodeRenderDataCanvas } from '../../../typings/pcode';
import { Bundle } from '../../common/requestsTypings';
import { CreativeOptionsData } from '../../CreativeOptions/typings';
import { AddCommonCreativeState, CommonCreativeItem } from '../typings';

import { getCommonPcodeRenderData } from './helpers';

export const selectPcodeData = createSelector(
    (state: AddCommonCreativeState) => state.currentId,
    (state: AddCommonCreativeState) => state.creativeOptions,
    (state: AddCommonCreativeState) => state.bundle,
    (state: AddCommonCreativeState) => state.items,
    (
        id?: number,
        creativeOptions?: CreativeOptionsData,
        bundle?: Bundle,
        items?: CommonCreativeItem[]
    ): PcodeRenderDataCanvas | undefined => {
        if (id === undefined || !creativeOptions || !bundle || !items) {
            return undefined;
        }

        const item = items.find(i => i.id === id);

        if (!item) {
            return undefined;
        }

        return getCommonPcodeRenderData(item, creativeOptions, bundle);
    }
);
